export default "__VITE_ASSET__DdwwsOdB__"